module.exports = __webpack_public_path__ + "img/index08.cc83e0ee.jpg";